<template>
  <div @submit.prevent="verify">
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="RadioIcon" class="mr-2 c-primary" />
        <span class="font-medium text-lg leading-none">Maggiori informazioni</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-6/12 w-full px-2 mt-4">
        <FilePick :disabled="is_readonly" label="Percorso lavoratore rilasciato dal Centro Impiego" v-model="form.doc_percorso_lavoratore" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4">
        <FilePick :disabled="is_readonly" label="Scheda Anagrafico/Professionale Centro Impiego" v-model="form.doc_scheda_anagrafico_professionale" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4">
        <FilePick class="w-full" :disabled="is_readonly" label="Documento d'identità in corso di validità" v-model="form.doc_identita" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4">
        <FilePick class="w-full" :disabled="is_readonly" label="Tessera sanitaria" v-model="form.doc_tessera_sanitaria" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4">
        <FilePick @input="setVal" class="w-full" :disabled="is_readonly" label="Curriculum Vitae" v-model="form.doc_cv" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4" v-if="form.tiroc_attestato_qualifica_prof">
        <FilePick class="w-full" :disabled="is_readonly" label="Attestato di Qualifica Professionale" v-model="form.doc_attestato_qualifica" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4">
        <FilePick class="w-full" :disabled="is_readonly" label="Documenti INPS per percettori NASPI" v-model="form.doc_inps" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4" v-if="form.tiroc_svolgimento_tirocini_prec">
        <FilePick class="w-full" :disabled="is_readonly" label="Progetti formativi tirocini precedenti" v-model="form.doc_progetti_formativi" />
      </vs-col>

      <vs-col class="md:w-6/12 w-full px-2 mt-4">
        <FilePick class="w-full" :disabled="is_readonly" label="Permesso di soggiorno in corso di validità" v-model="form.doc_permesso_soggiorno" />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  props: ['form','is_readonly'],
  components: {
  },

  data () {
    return {
      is_saving: false,
      conversion_table: {
        "Permesso di soggiorno in corso di validità" : "doc_permesso_soggiorno",
        "Progetti formativi tirocini precedenti" : "doc_progetti_formativi",
        "Documenti INPS per percettori NASPI" : "doc_inps",
        "Attestato di Qualifica Professionale" : "doc_attestato_qualifica",
        "Curriculum Vitae" : "doc_cv",
        "Tessera sanitaria" : "doc_tessera_sanitaria",
        "Documento d'identità in corso di validità" : "doc_identita",
        "Scheda Anagrafico/Professionale Centro Impiego" : "doc_scheda_anagrafico_professionale",
        "Percorso lavoratore rilasciato dal Centro Impiego" : "doc_percorso_lavoratore",
      }
    }
  },

  computed: {
    az () {
      return this.form.azienda
    },
  },

  methods: {
    setVal(v,str) {
      this.form[ this.conversion_table[str] ] = v
      this.updateTir()
    },
    updateTir() {
      if (this.form.stato == 'sent') {
        this.form.stato_modulo = 0  
      }
      this.$http.post(`modulo-tirocinio/salva?token=${this.form.token}`, this.form)
    }
  },
}
</script>

<style lang="scss">
.con-input-upload .text-input {
  font-weight: normal;
  // font-style: italic;
}
</style>
